import { Link } from "@remix-run/react";
import { Streamer } from "~/types";

type StreamerCardProps = {
  streamer: Streamer;
};

export default function StreamerCard({ streamer }: StreamerCardProps) {
  return (
    <Link key={streamer.id} to={`/gremlins/${streamer.username}`} className="min-w-max">
      <div className="bg-card flex flex-col items-center rounded-md border p-4 font-card lg:px-12 border-purple">
        <img src={streamer.profile_pic} className="w-28 rounded-full 2xl:w-44" />
        <div className="my-4 h-[1px] w-full bg-white/90"></div>
        <p className="text-xl font-semibold">{streamer.username}</p>
      </div>
    </Link>
  );
}
